// Dependencies
import styled from 'styled-components'
import { pageGutter } from 'styles/gutter'

// Utils
import { MediaQueries } from 'utils/breakpoints'

export const Background = styled.div`
  position: relative;
  width: 100%;
  padding: 24px 24px 56px 24px;
  background: #fff;
  box-shadow: 0px 12px 80px 0px rgba(0, 0, 0, 0.1);

  ${MediaQueries.medium} {
    padding: 24px 40px 56px 40px;
    gap: 32px;
    border-radius: 0px 0px 24px 24px;
  }

  ${MediaQueries.amedium} {
    ${pageGutter}

    padding: 32px 32px 64px 32px !important;
    border-radius: 24px;
    top: -230px;
  }
`

export const FormWrapper = styled.form`
  width: 100%;
  padding: 24px 24px 56px 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;

  ${MediaQueries.medium} {
    gap: 32px;
  }

  > .pdg-navbar-button {
    padding: 12px 28px 12px 32px;
    background-color: #df1d3d;
    color: #fdf4f5;
    font-weight: 400;

    position: absolute;
    bottom: -24px;
    right: 50%;
    transform: translateX(50%);
  }
`

export const HeaderItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;

  > img {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  > p {
    color: #df1d3d;
    font-family: 'Source Sans 3';
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }
`

export const InputsWrapper = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: 16px;
  grid-column-gap: 24px;
  grid-template-areas: 'first second' 'third fourth' 'fifth fifth';

  > :nth-child(1) {
    grid-area: first;
  }

  > :nth-child(2) {
    grid-area: second;
  }

  > :nth-child(3) {
    grid-area: third;
  }

  > :nth-child(4) {
    grid-area: fourth;
  }

  > :nth-child(5) {
    grid-area: fifth;
  }

  ${MediaQueries.medium} {
    display: flex;
    align-items: flex-start;
    gap: 24px;
  }
`

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  background: #f0f1f7;
`

export const SelectsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  ${MediaQueries.medium} {
    display: flex;
    flex-direction: row;
    gap: 24px;
  }
`
